/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UserVCSTokenResponse } from '../models/user-vcstoken-response';
import { UserVCSTokenRequest } from '../models/user-vcstoken-request';

/**
 * Ui User VCS Token Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiUserVcsTokenControllerService extends __BaseService {
  static readonly getAllUsingGET5Path = '/cc-ui/v1/user-token';
  static readonly addUsingPOST1Path = '/cc-ui/v1/user-token';
  static readonly updateUsingPUT2Path = '/cc-ui/v1/user-token';
  static readonly deleteUsingDELETE2Path = '/cc-ui/v1/user-token/{id}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAll
   * @return OK
   */
  getAllUsingGET5Response(): __Observable<
    __StrictHttpResponse<Array<UserVCSTokenResponse>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/user-token`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<UserVCSTokenResponse>>;
      }),
    );
  }
  /**
   * getAll
   * @return OK
   */
  getAllUsingGET5(): __Observable<Array<UserVCSTokenResponse>> {
    return this.getAllUsingGET5Response().pipe(
      __map((_r) => _r.body as Array<UserVCSTokenResponse>),
    );
  }

  /**
   * add
   * @param userVCSTokenRequest userVCSTokenRequest
   * @return OK
   */
  addUsingPOST1Response(
    userVCSTokenRequest: UserVCSTokenRequest,
  ): __Observable<__StrictHttpResponse<UserVCSTokenResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = userVCSTokenRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/user-token`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserVCSTokenResponse>;
      }),
    );
  }
  /**
   * add
   * @param userVCSTokenRequest userVCSTokenRequest
   * @return OK
   */
  addUsingPOST1(
    userVCSTokenRequest: UserVCSTokenRequest,
  ): __Observable<UserVCSTokenResponse> {
    return this.addUsingPOST1Response(userVCSTokenRequest).pipe(
      __map((_r) => _r.body as UserVCSTokenResponse),
    );
  }

  /**
   * update
   * @param userVCSTokenRequest userVCSTokenRequest
   * @return OK
   */
  updateUsingPUT2Response(
    userVCSTokenRequest: UserVCSTokenRequest,
  ): __Observable<__StrictHttpResponse<UserVCSTokenResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = userVCSTokenRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/cc-ui/v1/user-token`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserVCSTokenResponse>;
      }),
    );
  }
  /**
   * update
   * @param userVCSTokenRequest userVCSTokenRequest
   * @return OK
   */
  updateUsingPUT2(
    userVCSTokenRequest: UserVCSTokenRequest,
  ): __Observable<UserVCSTokenResponse> {
    return this.updateUsingPUT2Response(userVCSTokenRequest).pipe(
      __map((_r) => _r.body as UserVCSTokenResponse),
    );
  }

  /**
   * delete
   * @param id id
   */
  deleteUsingDELETE2Response(
    id: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/cc-ui/v1/user-token/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * delete
   * @param id id
   */
  deleteUsingDELETE2(id: string): __Observable<null> {
    return this.deleteUsingDELETE2Response(id).pipe(
      __map((_r) => _r.body as null),
    );
  }
}

module UiUserVcsTokenControllerService {}

export { UiUserVcsTokenControllerService };
